module.exports = __webpack_public_path__ + "static/media/facebook_full.8b3c98fe3ff22f675e696bb102a6016a.svg";